import { Fragment } from "react";
import cn from "classnames";
import { RowFormatterType, RowFormatterParams } from "../interfaces";

const DataTableToggleRowFormatter: RowFormatterType<any> = (
  props: RowFormatterParams<any>,
) => {
  const { index, cells, item, getBlocksWith } = props;

  return (
    <Fragment key={`data_${index}`}>
      <tr
        key={`data_row_${index}`}
        className={getBlocksWith("__body-row")}
        data-auto="table-row"
      >
        {cells}
      </tr>
      {item.open && (
        <tr
          key={`data_row_2_${index}`}
          id={`result${index}`}
          className={getBlocksWith("__body-row")}
          data-auto="table-expanded-row"
        >
          <td
            className={cn(
              getBlocksWith("__cell"),
              getBlocksWith("__cell--expanded"),
            )}
            colSpan={99}
            data-auto="table-expanded-data"
          >
            {item.renderRowContent(index)}
          </td>
        </tr>
      )}
    </Fragment>
  );
};

export default DataTableToggleRowFormatter;
